<template>
  <div class="vm-album-intro-edit">
    <section class="edit-cover">
      <div class="inner-box">
        <div class="edit-cover-placeholder self-center white">
          <p class="text-center mt16 fs14">{{$t('c.AlbumIntroEdit.text1')}}</p>
          <p class="text-center mt8 fs14">{{$t('c.AlbumIntroEdit.text2')}}</p>
        </div>
      </div>
    </section>
    <section class="edit-input mt8">
      <input type="text" class="gl-input fs30 fwb" :placeholder="$t('c.AlbumIntroEdit.text3')" />
    </section>
    <textarea class="gl-textarea mt16" :placeholder="$t('c.AlbumIntroEdit.text4')"></textarea>
    <btn v-if="browser_size != 'small'" class="w100 look7 pt16 pb16 mt16">{{$t('c.AlbumIntroEdit.text5')}}</btn>
    <btn v-if="browser_size != 'small'" class="w100 look1 pt16 pb16 mt16 fs16">{{$t('c.AlbumIntroEdit.text6')}}</btn>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //   n: this.browser_size == "small" ? 2 : 3
    };
  },
  computed: {},
  mounted() {},
  methods: {}
};
</script>

<style lang="stylus" scoped>
.vm-album-intro-edit {
  .edit-cover {
    flex-shrink: 0;
    height: auto;
    cursor: pointer;
    border-radius: 8px;

    .inner-box {
      // background: rgba(234, 234, 234, 1);
      padding-bottom: 100%;
      position: relative;
      height: auto;
      border-radius: 8px;
      background-position: center;
    }

    .edit-cover-placeholder {
      width: 128px;
      height: 75px;
      background: $black-3;
      border-radius: 8px;
    }
  }
}
</style>
